@for (training of trainingDetails; track training) {
  <div>
    <br/>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Training site name</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="$safeNavigationMigration(training?.trainingSiteName)"
          ></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Training site address</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="$safeNavigationMigration(training?.trainingSiteAddress)"
          ></div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Start date</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="($safeNavigationMigration(training?.trainingStartDate) | utcDate) || '-'"
          ></div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>End date</label>
          <div
            type="text"
            class="form-control readonly"
            [innerHTML]="($safeNavigationMigration(training?.trainingEndDate) | utcDate) || '-'"
          ></div>
        </div>
      </div>
    </div>
  </div>
}
